function _isTypeOf (type, a, b) {
  return [typeof a, typeof b].includes(type)
}

function _areStringsAndEquals (a, b) {
  if (typeof a === typeof b) {
    return a === b
  }
  return !!a === !!b
}

function _areNumbersAndEquals (a, b) {
  if (typeof a === 'number' && !Number.isNaN(a)) {
    return a === Number(b)
  }
  if (typeof b === 'number' && !Number.isNaN(b)) {
    return Number(a) === b
  }
  return false
}

function _areBooleanAndEquals (a, b) {
  if ('undefined'.includes(typeof a, typeof b) || a === null || b === null) {
    return false
  }
  return a === b
}

function _arePrimitivesAndEquals (a, b) {
  if (_isTypeOf('number', a, b)) {
    return _areNumbersAndEquals(a, b)
  }
  if (_isTypeOf('string', a, b)) {
    return _areStringsAndEquals(a, b)
  }
  return _areBooleanAndEquals(a, b)
}

function _isObjectFalsy (obj) {
  if (obj === null) return true
  if (obj instanceof Date) return false

  for (const key in obj) {
    if (!!obj[key] === true) {
      return false
    }
  }
  return true
}

function _isLooseEqual (prop, a, b, propsToIgnore) {
  if (prop in b) {
    if (typeof a[prop] === 'object' && typeof b[prop] === 'object') {
      if (a[prop] === null && b[prop] === null) {
        return true
      }
      if (a[prop] === null) {
        return _isObjectFalsy(b[prop])
      }
      if (b[prop] === null) {
        return _isObjectFalsy(a[prop])
      }
      if (a[prop] instanceof Date && b[prop] instanceof Date) {
        return a[prop].getTime() === b[prop].getTime()
      }
      return _isLooseDeepEqual(a[prop], b[prop], propsToIgnore)
    } else if (a[prop] !== b[prop]) {
      return _arePrimitivesAndEquals(a[prop], b[prop])
    }
  } else if (typeof a[prop] === 'object') {
    return _isObjectFalsy(a[prop])
  } else if (!a[prop]) {
    return false
  }
  return true
}

function _isLooseDeepEqual (a, b, propsToIgnore) {
  if (Array.isArray(a) && Array.isArray(b) && a.length !== b.length) {
    return false
  }
  for (const prop in a) {
    if (propsToIgnore.includes(prop)) {
      continue
    }
    if (!_isLooseEqual(prop, a, b, propsToIgnore)) {
      return false
    }
  }
  for (const prop in b) {
    if (propsToIgnore.includes(prop)) {
      continue
    }
    if (!_isLooseEqual(prop, a, b, propsToIgnore)) {
      return false
    }
  }
  return true
}

function looseDeepEqual (a, b, propsToIgnore = []) {
  if (a === undefined || b === undefined) {
    return true
  }
  return _isLooseDeepEqual(a, b, propsToIgnore)
}

export default looseDeepEqual



// WEBPACK FOOTER //
// ./client/utils/looseDeepEqual.js